import { Component, ReactNode } from "react";
import { Button } from "@/components/ui/button";

interface Props { children: ReactNode }
interface State { error: Error | null }

class AdminErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: unknown) {
    console.error("[AdminErrorBoundary]", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-6">
          <div className="max-w-md text-center space-y-4">
            <h1 className="font-heading text-2xl text-foreground">Une erreur est survenue</h1>
            <p className="font-body text-sm text-muted-foreground">
              Le tableau de bord admin a rencontré un problème. Vous pouvez réessayer ou recharger la page.
            </p>
            <pre className="text-xs text-muted-foreground bg-secondary/40 rounded p-3 overflow-auto max-h-40 text-left">
              {this.state.error.message}
            </pre>
            <div className="flex gap-2 justify-center">
              <Button onClick={this.reset} variant="outline">Réessayer</Button>
              <Button onClick={() => window.location.reload()}>Recharger</Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AdminErrorBoundary;